import React from "react";

import { useIntl } from "react-intl";

import * as Dropdown from "ds/Dropdown";

import CLICommand from "./cli/CLI";
import GitCliCommand from "./git/Git";
import * as S from "./style";

type CodeProps = {
  gitCommand: string;
  platformCommand: string;
};

const Code = ({ gitCommand, platformCommand }: CodeProps) => {
  const formatMessage = useIntl().formatMessage;
  return (
    <Dropdown.CommandMenu
      triggerLabel={formatMessage({ id: "code_trigger_btn" })}
      tabs={[
        {
          id: "code-tab-cli",
          label: formatMessage({ id: "cli" }),
          component: (
            <S.ContentWrapper>
              <CLICommand command={platformCommand} />
            </S.ContentWrapper>
          )
        },
        {
          id: "code-tab-git",
          label: formatMessage({ id: "git" }),
          component: (
            <S.ContentWrapper>
              <GitCliCommand command={gitCommand} />
            </S.ContentWrapper>
          )
        }
      ]}
    />
  );
};

export default Code;
